import React from 'react';
import { useAuthState } from './hooks';

// Firebase deps
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

//Components
import Userslist  from './components/temps/userslist';
import Channel from './components/Channel';
import Navbar from './components/temps/navbar';


firebase.initializeApp({
  apiKey: "AIzaSyDJQaKiPedR2BNrooPw6a6a5A5gibInFhM",
  authDomain: "batcheet-10.firebaseapp.com",
  projectId: "batcheet-10",
  storageBucket: "batcheet-10.appspot.com",
  messagingSenderId: "833364426046",
  appId: "1:833364426046:web:2b4fd0106e146106aa806f",
  measurementId: "G-B39KG1RZN9"
});


function App() {
  const { user, initializing } = useAuthState(firebase.auth());
  if (initializing) return 'loading....';
  return (
    <div>
      <Navbar />
      {
        user ? (
          <>
            <div >
              <div className="w-full inline-block max-w-xs border-r-2 md:h-screen align-top">
                <Userslist user={user} />
              </div>
              <div className="w-full inline-block max-w-5xl border-r-2 align-top">
                <Channel user={user} />
              </div>
            </div> 
          </>
        ) : 
        <div className="text-center mt-8">
            <p className="text-3xl font-bold">BatCheet - RealTime chat app </p>
            <p>created using ReactJs and Firebase</p>
            <p>Just Signup using Google and start your BatCheet </p>

            <p className="mt-10">( App is still under working..... )</p>
        </div>
      }
    </div>
  );
}

export default App;
